// Runtime configuration loaded from /config.json (written per-environment by
// the deploy workflow, ATC-055). Loading at runtime keeps one build portable
// across staging and prod. See public/config.json for the shape.

export interface AppConfig {
  aadClientId: string
  aadAuthority: string
  apiScope: string
  opsGroupId: string
  licensingBaseUrl: string
  mintBaseUrl: string
}

let cached: AppConfig | null = null

export async function loadConfig(): Promise<AppConfig> {
  if (cached) {
    return cached
  }
  const res = await fetch('/config.json', { cache: 'no-store' })
  if (!res.ok) {
    throw new Error(`Failed to load /config.json (HTTP ${res.status})`)
  }
  const raw = (await res.json()) as Partial<AppConfig>
  const required: (keyof AppConfig)[] = [
    'aadClientId',
    'aadAuthority',
    'apiScope',
    'opsGroupId',
    'licensingBaseUrl',
    'mintBaseUrl',
  ]
  for (const key of required) {
    if (!raw[key]) {
      throw new Error(`config.json is missing required field: ${key}`)
    }
  }
  cached = raw as AppConfig
  return cached
}

// Test-only reset so config can be re-loaded with different fixtures.
export function __resetConfigForTests(): void {
  cached = null
}
